const staticPageInitialState = {
	privacyPolicyPage: {},
	contactPage: {},
};

export default staticPageInitialState;